import React from 'react';
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Text,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  useColorModeValue,
  Icon,
} from '@chakra-ui/react';
import { FaUserAlt } from 'react-icons/fa';

const BasicInfoCard = ({ addUser, setAddUser }) => {
  const modalTextColor = useColorModeValue('gray.800', 'white');
  const labelColor = useColorModeValue('gray.700', 'gray.200');
  const inputBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const inputPlaceholderColor = useColorModeValue('gray.500', 'gray.400');
  const hoverBorderColor = useColorModeValue('blue.400', 'blue.300');
  const focusBorderColor = useColorModeValue('blue.500', 'blue.400');
  const cardBg = useColorModeValue('white', 'gray.800');

  return (
    <Card
      mb={6}
      boxShadow="sm"
      border="1px solid"
      borderColor={borderColor}
      bg={cardBg}
    >
      <CardBody>
        <VStack align="start" spacing={4}>
          <HStack spacing={2}>
            <Icon as={FaUserAlt} color="blue.500" />
            <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
              Basic Information
            </Text>
          </HStack>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="full">
            <FormControl isRequired>
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Full Name
              </FormLabel>
              <Input
                value={addUser.name}
                onChange={(e) =>
                  setAddUser((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
                placeholder="Enter full name"
                bg={inputBg}
                borderColor={borderColor}
                color={inputTextColor}
                _placeholder={{ color: inputPlaceholderColor }}
                _hover={{ borderColor: hoverBorderColor }}
                _focus={{
                  borderColor: focusBorderColor,
                  boxShadow: `0 0 0 1px ${focusBorderColor}`,
                }}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
                Phone Number
              </FormLabel>
              <Input
                value={addUser.phoneNo}
                onChange={(e) =>
                  setAddUser((prev) => ({
                    ...prev,
                    phoneNo: e.target.value,
                  }))
                }
                placeholder="Enter phone number"
                bg={inputBg}
                borderColor={borderColor}
                color={inputTextColor}
                _placeholder={{ color: inputPlaceholderColor }}
                _hover={{ borderColor: hoverBorderColor }}
                _focus={{
                  borderColor: focusBorderColor,
                  boxShadow: `0 0 0 1px ${focusBorderColor}`,
                }}
              />
            </FormControl>
          </SimpleGrid>

          <FormControl isRequired w="full">
            <FormLabel fontSize="sm" fontWeight="medium" color={labelColor}>
              User ID
            </FormLabel>
            <Input
              value={addUser.userId || ''}
              onChange={(e) =>
                setAddUser((prev) => ({
                  ...prev,
                  userId: e.target.value,
                }))
              }
              placeholder="Enter unique user ID"
              bg={inputBg}
              borderColor={borderColor}
              color={inputTextColor}
              _placeholder={{ color: inputPlaceholderColor }}
              _hover={{ borderColor: hoverBorderColor }}
              _focus={{
                borderColor: focusBorderColor,
                boxShadow: `0 0 0 1px ${focusBorderColor}`,
              }}
            />
          </FormControl>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default BasicInfoCard;
